import {styled} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import styles from './ActionModal.scss';
import DialogContent from '@material-ui/core/DialogContent';
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import {BUTTON, Button} from 'components/common/Button/Button';

const ActionModalDialog = styled(Dialog)(() => ({
    '& .MuiPaper-root': {
        overflow: 'visible',
    },
    '& .MuiDialogContent-root': {
        overflowY: 'visible',
    },
}));

const titleStyles = theme => ({
    root: {
        color: '#28282e',
        margin: 0,
        padding: '16px 24px',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const ActionModal = props => {
    const { isOpen, title, onSave, onClose, CustomModalFooter, onSaveText } = props;
    return (
        <div>
            <ActionModalDialog
                open={isOpen}
                onClose={onClose}
                fullWidth
                aria-labelledby="form-dialog-title"
                className={styles.dialogContainer}
                data-cy="ActionModal"
            >
                <DialogTitle onClose={onClose} title={title}/>
                <DialogContent>
                    { props.children }
                </DialogContent>
                {
                    CustomModalFooter ?  CustomModalFooter : <DialogButtons onSaveText={onSaveText || 'Confirm'} onClose={onClose} onSave={onSave}/>
                }
            </ActionModalDialog>
        </div>
    );
};

const DialogTitle = withStyles(titleStyles)(props => {
    const {title, classes, onClose} = props;
    return (
        <MuiDialogTitle disableTypography data-cy="ActionModal-MuiDialogTitle">
            <Typography variant="h6" data-cy="ActionModal-h6">{title}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} data-cy="ActionModal-onClose">
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogButtons = ({onClose, onSave, onSaveText}) => {
    return (
        <DialogActions className={styles.dialogAction} data-cy="ActionModal-DialogButtons">
            <Button
                className={styles.btnOutline}
                onClick={onClose}
                bgcolor={BUTTON.BGCOLOR.CLEAR}
                color={BUTTON.COLOR.GREY}
                data-cy="ActionModal-onClick"
            >
                Cancel
            </Button>
            <Button
                onClick={onSave}
                bgcolor={BUTTON.BGCOLOR.ORANGE}
                color={BUTTON.COLOR.WHITE}
                data-cy="ActionModal-onSave"
            >
                {onSaveText}
            </Button>
        </DialogActions>
    );
};

export default ActionModal;
